module.exports = __webpack_public_path__ + "static/img/detail-t20.1b31ca08.png";